import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const ScreenShareIcon = (p: IconProps) => (
  <Icon {...p}>
    <rect width="20" height="14" x="2" y="3" rx="2" />
    <path d="M8 21h8" />
    <path d="M12 17v4" />
    <path d="m9 10 3-3 3 3" />
    <path d="M12 7v6" />
  </Icon>
)
